export default __webpack_public_path__ + "static/media/planeboi.67659030.png";